
























import React from "react";
import "../../styles/IndianGraniteExpress.css";
import graniteImage from "../../images/granite-slider.jpg";
import granite1 from "../../assets/granite1.jpg"; 
import granite2 from "../../assets/granite2.jpg"; 
import shipIcon from "../../assets/service-icon.png"; // Import the ship icon
import { Link } from "react-router-dom";

const IndianGraniteExpress = () => {
  return (
    <div className="granite-container">
      {/* Image Slider - Full width like homepage */}
      <div className="granite-image-slider">
        <img src={graniteImage} alt="Indian Granite Express Slider" />
      </div>

      {/* Main Content Container */}
      <div className="granite-content">
        {/* Content Card with title inside */}
        <div className="granite-card">
          {/* Title with Icon - Added back to the component */}
          <div className="granite-title-header">
            <img src={shipIcon} alt="Granite Service" className="granite-title-icon rotate-on-hover" />
            <h3 className="granite-title-text">Indian Granite Express</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="card-left">
            <div className="granite-image-container first-image">
              <img src={granite1} alt="Granite Loading" className="granite-img" />
            </div>
            <div className="granite-image-container second-image">
              <img src={granite2} alt="Granite Transport" className="granite-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="card-right">
            <p className="granite-text">
              Cut to specifications for the granite industry, the Indian Granite Express has been a name
              synonymous with the trade for almost three decades. With an emphasis on minimum transit time
              and flexibility, the Indian Granite Express has been the backbone of granite movements,
              shipping over a million tons of granite spread over a hundred sailings annually.
            </p>
            <p className="granite-text">
              Puyvast is the largest granite carrier from India to most destinations all over the world.
            </p>
            <p className="granite-text">
              With a minimum of six monthly sailings from Kandla, Goa, Karwar, Mangalore and Tuticorin on the
              West Coast, and Vizag, Kakinada, Krishnapatnam and Chennai on the East Coast, to several
              destinations in South East Asia and the Far East, this express service delivers cargo within a
              maximum transit time of 25 days.
            </p>
            <p className="granite-text">
              Puyvast also offers regular monthly sailings to North European, Mediterranean, Scandinavian
              and UK Ports and largely services the port of Antwerp, which is the gateway for all granite
              shipments to Europe.
            </p>
            
            {/* Destinations section with blue background */}
            <div className="granite-blue-header">
              <img src={shipIcon} alt="Destinations" className="granite-header-icon rotate-on-hover" />
              <div className="granite-vertical-line"></div>
              <h3 className="granite-header-title">A partial list of destinations serviced include:</h3>
            </div>
            <ul className="destinations-list">
              <li>
                <span className="destination-icon moving-ship">🚢</span> 
                <span className="destination-text"><h5>Towards Far East :</h5> Hualien / Hong Kong / Xiamen / Shihu / HCMC.</span>
              </li>
              <li>
                <span className="destination-icon moving-ship">🚢</span> 
                <span className="destination-text">
                <h5>Towards Europe :</h5> Marina di Carrara / Porto Marghera / Alicante / Leixoes / Vigo / Bilbao /
                  Pasajes / Rotterdam / Antwerp / Gdansk / Stettin.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer - Same as homepage */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default IndianGraniteExpress;